

















import { defineComponent, computed, PropType } from '@vue/composition-api';
import { ButtonSizes, ButtonAlignment, ButtonThemes } from './types';

export const BUTTON_TEXT_SIZES: ButtonSizes = {
  small: 'button-small',
  big: 'button-med',
  default: '',
};

export const BUTTON_ALIGNMENT: ButtonAlignment = {
  left: 'fc-button--left',
  center: '',
  right: 'fc-button--right',
};

export default defineComponent({
  name: 'FCButton',
  props: {
    id: {
      type: String,
      required: false,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
      required: false,
    },
    buttonTheme: {
      type: String as PropType<ButtonThemes>,
      required: false,
      default: 'button-primary',
    },
    customEventName: {
      type: String,
      required: true,
    },
    buttonSize: {
      type: String,
      required: false,
      default: 'default',
    },
    useHeadingFont: {
      type: Boolean,
      required: false,
      default: false,
    },
    buttonAlignment: {
      type: String,
      required: false,
      default: 'left',
    },
    ariaLabel: {
      type: String,
      required: false,
      default: null,
    },
    fullWidth: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props, context) {
    const isDisabled = computed(() => props.buttonTheme === 'button-disabled' || props.loading);

    const themeClass = computed(() => {
      // Text button has simple styling with no additional classes
      if (props.buttonTheme === 'button-text') {
        return props.buttonTheme;
      }

      // Build class list based on the button state and properties
      const classes = ['button-layout'];

      // Handle disabled state
      if (isDisabled.value) {
        classes.push('button-disabled', 'fc-button--disabled');
      } else {
        // Add theme only for non-disabled buttons
        classes.push(props.buttonTheme);
      }

      // Add size class
      classes.push(BUTTON_TEXT_SIZES[props.buttonSize as keyof ButtonSizes]);

      // Add heading font if enabled
      if (props.useHeadingFont) {
        classes.push('fc-heading-5');
      }

      return classes.join(' ');
    });

    return {
      emitCustomEvent() {
        context.emit(props.customEventName);
      },
      isDisabled,
      getContainerClass: computed(() => (props.fullWidth ? 'fc-block' : 'fc-flex')),
      widthClass: computed(() => (props.fullWidth ? 'fc-button--full-width' : (BUTTON_ALIGNMENT)[props.buttonAlignment as keyof ButtonAlignment])),
      themeClass,
    };
  },
});
